import React, { useState, useEffect } from 'react';
import './DateRangeSelector.css';

const DateRangeSelector = ({ onFetchPlanning, loading, initialDateDebut, initialDateFin }) => {
  // Fonction pour convertir MM-DD-YYYY vers YYYY-MM-DD
  const convertToInputFormat = (apiDate) => {
    if (!apiDate) return '';
    const [month, day, year] = apiDate.split('-');
    return `${year}-${month}-${day}`;
  };

  const [dateDebut, setDateDebut] = useState(convertToInputFormat(initialDateDebut) || '');
  const [dateFin, setDateFin] = useState(convertToInputFormat(initialDateFin) || '');
  const [errors, setErrors] = useState({});

  // Mettre à jour les dates si les valeurs initiales changent
  useEffect(() => {
    if (initialDateDebut) {
      setDateDebut(convertToInputFormat(initialDateDebut));
    }
    if (initialDateFin) {
      setDateFin(convertToInputFormat(initialDateFin));
    }
  }, [initialDateDebut, initialDateFin]);

  const validateDates = () => {
    const newErrors = {};

    if (!dateDebut) {
      newErrors.dateDebut = 'La date de début est obligatoire';
    }

    if (!dateFin) {
      newErrors.dateFin = 'La date de fin est obligatoire';
    }

    if (dateDebut && dateFin) {
      const debut = new Date(dateDebut);
      const fin = new Date(dateFin);

      if (debut > fin) {
        newErrors.dateFin = 'La date de fin doit être après la date de début';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatDateForAPI = (dateString) => {
    // dateString est au format YYYY-MM-DD (format HTML input date)
    const [year, month, day] = dateString.split('-');
    // Retourner au format MM-DD-YYYY (format attendu par le backend)
    const formatted = `${month}-${day}-${year}`;
    console.log('Date formatée:', dateString, '->', formatted);
    return formatted;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateDates()) {
      const formattedDebut = formatDateForAPI(dateDebut);
      const formattedFin = formatDateForAPI(dateFin);
      console.log('Appel API avec dates:', formattedDebut, formattedFin);
      onFetchPlanning(formattedDebut, formattedFin);
    }
  };

  return (
    <div className="date-range-selector">
      <form onSubmit={handleSubmit} className="date-form">
        <div className="date-inputs">
          <div className="form-field">
            <label htmlFor="dateDebut">
              <svg className="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              Date de début
            </label>
            <input
              type="date"
              id="dateDebut"
              value={dateDebut}
              onChange={(e) => {
                setDateDebut(e.target.value);
                setErrors({ ...errors, dateDebut: null });
              }}
              className={errors.dateDebut ? 'error' : ''}
              disabled={loading}
            />
            {errors.dateDebut && <span className="error-text">{errors.dateDebut}</span>}
          </div>

          <div className="form-field">
            <label htmlFor="dateFin">
              <svg className="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              Date de fin
            </label>
            <input
              type="date"
              id="dateFin"
              value={dateFin}
              onChange={(e) => {
                setDateFin(e.target.value);
                setErrors({ ...errors, dateFin: null });
              }}
              className={errors.dateFin ? 'error' : ''}
              disabled={loading}
            />
            {errors.dateFin && <span className="error-text">{errors.dateFin}</span>}
          </div>
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-small"></span>
              Chargement...
            </>
          ) : (
            <>
              <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="9 11 12 14 22 4"></polyline>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
              Afficher la planification et le bilan
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default DateRangeSelector;
